<template>
    <GiVendorIndex
        pageTitle="Good Issue (Vendor Warehouse)"
        :useVendorWarehouseModal="true"
        :isCentralWarehouse="false"
        :includeCentralWarehouseParam="true"
    />
</template>

<script>
import GiVendorIndex from "../components/GiVendorIndex.vue";
import { ORDER_TYPE } from "@/constants/outbound";

export default {
    components: {
        GiVendorIndex,
    },

    computed: {
        orderTypeReg() {
            return ORDER_TYPE.REG;
        }
    }
};
</script>